<template>
  <div class="incomming-component">
    <img class="incomming-background" :src="data.background" alt="" />
    <div class="btn-list">
      <div
        class="btn-item"
        :style="getBtnStyle(item)"
        v-for="(item, index) in data.btns"
        @click="handleClick(item)"
        :key="index"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      default: null,
      type: Object
    }
  },
  data() {
    return {
      scale: 1
    }
  },
  computed: {},
  created() {
    let designWidth = 375
    let screenWidth = window.screen.width
    this.scale = Math.floor((screenWidth / designWidth) * 100) / 100
  },
  methods: {
    getBtnStyle(item) {
      return {
        width: item.width * this.scale + 'px',
        height: item.height * this.scale + 'px',
        left: item.left * this.scale + 'px',
        top: item.top * this.scale + 'px'
      }
    },
    handleClick(item) {
      if (item.route) {
        this.$betterwe.jumpRoute(item.route)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.incomming-component {
  position: relative;
  .incomming-background {
    width: 100%;
  }
  .btn-list {
    .btn-item {
      z-index: 1;
      position: absolute;
    }
  }
}
</style>
